import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const API_BASE = '';

const GAMES = [
  { name: 'AVIATOR', uid: 'a04d1f3eb8ccec8a4823bdf18e3f0e84', image: 'https://cdn.dreamdelhi.com/mac88lite/mini_aviator.webp', players: 212, badgeColor: '#e53935' },
  { name: 'LIMBO', uid: 'fd01295cf73d124112b3f865738d7eab', image: 'https://cdn.dreamdelhi.com/mac88lite/mini_limbo.webp', players: 212, badgeColor: '#43a047' },
  { name: 'DICE', uid: '80ad35ede55f78fbd73e74505b5b6134', image: 'https://cdn.dreamdelhi.com/mac88lite/mini_dice.webp', players: 199, badgeColor: '#e53935' },
  { name: 'XROULETTE', uid: '8fdb4607fdcd6e9cf0458b92a98558ff', image: 'https://cdn.dreamdelhi.com/mac88lite/mini_slide.webp', players: 218, badgeColor: '#7b2ff7' },
  { name: 'CRASH X', uid: 'ca04bdb935a510f908193abef2b95b02', image: 'https://cdn.dreamdelhi.com/mac88lite/mini_crashx.webp', players: 121, badgeColor: '#f57c00' },
  { name: 'COIN FLIP', uid: '4a368a4e7e7421a2c83fca8eaf5c07a3', image: 'https://cdn.dreamdelhi.com/mac88lite/mini_coinflip.webp', players: 123, badgeColor: '#1976d2' },
  { name: 'RPS', uid: 'd51a9db17cd6b8d613ef9861412d605a', image: 'https://cdn.dreamdelhi.com/mac88lite/mini_rps.webp', players: 203, badgeColor: '#43a047' },
  { name: 'FORTUNE WHEEL', uid: 'f73d28f118be9e9ce7152be41bbcce28', image: 'https://cdn.dreamdelhi.com/mac88lite/mini_fortune_wheel.webp', players: 193, badgeColor: '#7b2ff7' },
  { name: 'JETX', uid: 'e0402c58af3c567366aa6cf0f5821980', image: 'https://cdn.dreamdelhi.com/mac88lite/mini_jetx.webp', players: 166, badgeColor: '#1976d2' },
];

const TOTAL_SLIDES = Math.ceil(GAMES.length / 3);

const MiniLobby = () => {
  const [open, setOpen] = useState(false);
  const [animating, setAnimating] = useState(false);
  const [slideIndex, setSlideIndex] = useState(0);
  const [gameUrl, setGameUrl] = useState(null);
  const touchRef = useRef(0);
  const navigate = useNavigate();

  const openLobby = () => {
    setAnimating(true);
    setTimeout(() => { setAnimating(false); setOpen(true); setSlideIndex(0); setGameUrl(null); }, 1000);
  };

  const closeLobby = () => { setOpen(false); setGameUrl(null); };

  const launch = async (uid) => {
    const token = localStorage.getItem('reddyannabook_token');
    if (!token) { closeLobby(); navigate('/login'); return; }
    try {
      const res = await fetch(`${API_BASE}/api/casino-launch.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ game_uid: uid, platform: window.innerWidth < 768 ? 2 : 1 }),
      });
      const data = await res.json();
      const url = data.game_url || data.url;
      if (url) { setGameUrl(url); }
      else { alert(data.msg || 'Game launch failed'); }
    } catch { alert('Connection error'); }
  };

  // Touch swipe only
  const onTS = (e) => { touchRef.current = e.touches[0].clientX; };
  const onTE = (e) => {
    const diff = touchRef.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) setSlideIndex(p => Math.min(p + 1, TOTAL_SLIDES - 1));
      else setSlideIndex(p => Math.max(p - 1, 0));
    }
  };

  return (
    <>
      <style>{CSS}</style>

      {/* Intro animation */}
      {animating && (
        <div className="mlb-intro">
          <img src="/images/poker.png" alt="" className="mlb-intro-chip" />
          <div className="mlb-intro-text">MINI LOBBY</div>
        </div>
      )}

      {/* Chip button — hidden when open or animating */}
      {!open && !animating && (
        <div className="mlb-chip" onClick={openLobby}>
          <img src="/images/poker.png" alt="Casino" />
        </div>
      )}

      {/* Popup — no overlay behind it */}
      <div className={`mlb-popup ${open ? 'mlb-open' : ''}`} style={gameUrl ? { maxHeight: '80vh' } : {}}>
        {/* X close button */}
        <button onClick={closeLobby} style={{
          position:'absolute',top:8,right:8,background:'#d9534f',color:'#fff',
          border:'none',borderRadius:'50%',width:28,height:28,fontSize:16,
          fontWeight:'bold',cursor:'pointer',zIndex:10,display:'flex',
          alignItems:'center',justifyContent:'center',lineHeight:1,
        }}>✕</button>

        <div className="mlb-hdr">
          <span className="mlb-title">Lobby</span>
          <span className="mlb-cnt">{GAMES.length}</span>
        </div>

        {gameUrl ? (
          /* Game iframe inside popup */
          <div style={{
            width:'100%',height:300,position:'relative',
            borderRadius:12,overflow:'hidden',marginTop:10,
          }}>
            <button onClick={() => setGameUrl(null)} style={{
              position:'absolute',top:5,right:5,zIndex:10,background:'#d9534f',
              color:'#fff',border:'none',borderRadius:'50%',width:26,height:26,
              cursor:'pointer',fontWeight:'bold',fontSize:14,display:'flex',
              alignItems:'center',justifyContent:'center',
            }}>✕</button>
            <iframe src={gameUrl} style={{width:'100%',height:'100%',border:'none'}} allow="fullscreen" title="Mini Game" />
          </div>
        ) : (
          /* Games slider */
          <div className="mlb-slider" onTouchStart={onTS} onTouchEnd={onTE}>
            <div className="mlb-track" style={{ transform: `translateX(-${slideIndex * 100}%)` }}>
              {GAMES.map((g, i) => (
                <div key={i} className="mlb-slide-card" onClick={() => launch(g.uid)}>
                  <div className="mlb-border-wrap">
                    <div className="mlb-card" style={{ animationDelay: `${(i % 3) * 0.3}s` }}>
                      <div className="mlb-img-wrap">
                        <img src={g.image} alt={g.name} />
                        <span className="mlb-badge" style={{ background: g.badgeColor }}>MORE SLOTS</span>
                        <span className="mlb-players"><span>👤</span>{g.players}</span>
                      </div>
                      <div className="mlb-name">{g.name}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const CSS = `
/* Chip */
.mlb-chip{position:fixed;bottom:150px;right:15px;width:60px;height:60px;z-index:9998;cursor:pointer;animation:mlbFloat 3s ease-in-out infinite}
.mlb-chip img{width:100%;height:100%;object-fit:contain;filter:drop-shadow(0 4px 12px rgba(123,47,247,0.5))}
@media(min-width:768px){.mlb-chip{display:none!important}.mlb-popup{display:none!important}.mlb-intro{display:none!important}}
@keyframes mlbFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}}

/* Intro animation */
.mlb-intro{position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,0.9);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px}
.mlb-intro-chip{width:80px;height:80px;animation:mlbSpin 0.8s ease-in-out}
.mlb-intro-text{color:#f9df10;font-size:28px;font-weight:900;letter-spacing:6px;text-shadow:0 0 20px #f9df10,0 0 40px rgba(249,223,16,0.4);animation:mlbFadeText 0.5s ease 0.5s both;font-family:'Lato',sans-serif}
@keyframes mlbSpin{0%{transform:scale(0) rotate(0deg);opacity:0}50%{transform:scale(1.3) rotate(180deg);opacity:1}100%{transform:scale(1) rotate(360deg);opacity:1}}
@keyframes mlbFadeText{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}

/* Popup — no overlay */
.mlb-popup{position:fixed;bottom:0;right:0;width:100%;max-width:100%;background:linear-gradient(180deg,#0d0d1a 0%,#111128 50%,#0a0a18 100%);border-radius:24px 24px 0 0;padding:12px;z-index:9997;transform:translateY(100%);transition:transform 0.35s cubic-bezier(0.16,1,0.3,1);max-height:75vh;overflow-y:auto;overflow-x:hidden}
.mlb-popup.mlb-open{transform:translateY(0)}
.mlb-popup::-webkit-scrollbar{width:0;display:none}

/* Header */
.mlb-hdr{display:flex;align-items:center;gap:10px;margin-bottom:14px;padding:0 4px}
.mlb-title{color:#fff;font-weight:800;font-size:20px;letter-spacing:0.5px;font-family:'Lato',sans-serif}
.mlb-cnt{background:#f9df10;color:#000;border-radius:12px;padding:2px 10px;font-size:12px;font-weight:800}

/* Slider */
.mlb-slider{overflow:hidden;width:100%;padding:8px 0 12px}
.mlb-track{display:flex;transition:transform 0.4s ease}
.mlb-slide-card{flex:0 0 33.333%;padding:0 4px;box-sizing:border-box}

/* Gradient border wrapper */
.mlb-border-wrap{background:linear-gradient(135deg,#9c27b0,#3f51b5,#00bcd4);border-radius:16px;padding:2px;height:100%}

/* Card */
.mlb-card{background:linear-gradient(180deg,#0d0d1a 0%,#1a0533 100%);border-radius:14px;overflow:hidden;cursor:pointer;height:100%;animation:mlbGlow 2s ease-in-out infinite;transition:transform 0.2s}
.mlb-card:active{transform:scale(0.95)}
@keyframes mlbGlow{0%,100%{box-shadow:0 0 10px rgba(156,39,176,0.4)}50%{box-shadow:0 0 25px rgba(156,39,176,0.8),0 0 40px rgba(63,81,181,0.4)}}

/* Image wrap */
.mlb-img-wrap{position:relative;overflow:hidden}
.mlb-img-wrap img{width:100%;height:155px;object-fit:cover;display:block}

/* Badge */
.mlb-badge{position:absolute;top:6px;left:6px;color:#fff;font-size:9px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;padding:2px 6px;border-radius:4px}

/* Players */
.mlb-players{position:absolute;top:6px;right:6px;background:#f9df10;color:#000;border-radius:10px;padding:2px 8px;font-size:10px;font-weight:700;display:flex;align-items:center;gap:2px}

/* Name */
.mlb-name{color:#fff;font-size:13px;font-weight:800;font-style:italic;letter-spacing:3px;text-transform:uppercase;text-align:center;padding:8px 4px;background:transparent}
`;

export default MiniLobby;
